import { render, staticRenderFns } from "./issues.vue?vue&type=template&id=bc7fb1c4&scoped=true&"
import script from "./issues.vue?vue&type=script&lang=js&"
export * from "./issues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7fb1c4",
  null
  
)

export default component.exports